/*!
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

// THIS FILE IS GENERATED BY BUILD TOOL
// DO NOT EDIT IT MANUAL
import { wrapIcon } from '../../wrapIcon';
import { SVGProps } from 'react';
const SvgRelationshipAddBase = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M8.08772 15.775L15.864 7.11238M13.6243 18.2986H17.3121M17.3121 18.2986H21M17.3121 18.2986V14.6M17.3121 18.2986V21.9973M20.9476 4.98157C20.9476 6.62825 19.6084 7.96315 17.9563 7.96315C16.3043 7.96315 14.9651 6.62825 14.9651 4.98157C14.9651 3.3349 16.3043 2 17.9563 2C19.6084 2 20.9476 3.3349 20.9476 4.98157ZM8.98254 17.9017C8.98254 19.5484 7.6433 20.8833 5.99127 20.8833C4.33924 20.8833 3 19.5484 3 17.9017C3 16.255 4.33924 14.9202 5.99127 14.9202C7.6433 14.9202 8.98254 16.255 8.98254 17.9017Z"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
const SvgRelationshipAdd = wrapIcon(SvgRelationshipAddBase);
export default SvgRelationshipAdd;
